"use client";

import { useEffect, useState } from "react";
import { bg, text, corners } from "@/lib/tokens/semantic";
import { mix } from "@/lib/tokens/mix";
import { colors } from "@/lib/tokens/primitives";
import { Icon } from "@kit/core";

export function AccessDenied() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(180deg, ${bg.sunken} 0%, ${bg.base} 50%, ${bg.elevated} 100%)`,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 32,
      fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      {/* Gem Icon */}
      <div style={{
        width: 80,
        height: 80,
        borderRadius: "var(--cg-radius-2xl)",
        background: `linear-gradient(135deg, ${bg.surface} 0%, ${bg.surfaceHover} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: `0 8px 32px ${mix(colors.black, 30)}, inset 0 1px 0 ${bg.surfaceActive}`,
        marginBottom: 24,
        animation: "float 3s ease-in-out infinite",
      }}>
        <Icon name="gem" size="xl" color="accent" />
      </div>

      {/* Title */}
      <h1 style={{
        color: text.primary,
        fontSize: 22,
        fontWeight: 700,
        margin: 0,
        marginBottom: 8,
        letterSpacing: "-0.02em",
      }}>
        Private Space
      </h1>

      {/* Subtitle */}
      <p style={{
        color: text.muted,
        fontSize: 15,
        textAlign: "center",
        margin: 0,
        marginBottom: 32,
        lineHeight: 1.5,
        maxWidth: 260,
      }}>
        This mini-app is available<br />
        only for authorized users
      </p>

      {/* Lock indicator */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 20px",
        background: bg.surface,
        borderRadius: corners.card,
        border: `1px solid ${bg.surfaceHover}`,
      }}>
        <Icon name="lock" size="sm" color="default" />
        <span style={{ color: text.tertiary, fontSize: 13, fontWeight: 500 }}>
          Access restricted
        </span>
      </div>

      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
      `}</style>
    </div>
  );
}
